import React, { useState } from 'react';
import { Button, Card, Col, Divider, Input, notification, Row } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';

import { saveSecurityDetailsAction } from '../../../actions/UserActions';

// import '@ant-design/compatible/assets/index.css';


const Security = ({ form }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [confirmDirty, setConfirmDirty] = useState(false);

  const { currentUser } = useSelector(store => ({
    currentUser: store.userReducer.currentUser,
  }));

  const handleConfirmBlur = e => {
    const { value } = e.target;
    setConfirmDirty(confirmDirty || !!value);
  };

  const compareToFirstPassword = (rule, value, callback) => {
    if (value && value !== form.getFieldValue('newPassword')) {
      callback(t('users.passwordsInconsistent'));
    } else {
      callback();
    }
  };

  const validateToNextPassword = (rule, value, callback) => {
    if (value && confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  const handleSubmit = e => {
    e.preventDefault();
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {

        dispatch(saveSecurityDetailsAction(values, currentUser.id));
        notification.success({
          message: t('common.save'),
          description: t('profile.detailsUpdated'),
        });
      }
    });
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  const { getFieldDecorator } = form;

  return (
    <Card bordered={false}>
      <Row>
        <Col span={16} offset={2}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Form {...formItemLayout} onSubmit={handleSubmit}>
            <Form.Item label={t('common.username')}>
              {getFieldDecorator('username', {
                initialValue:
                  currentUser && currentUser.username
                    ? currentUser.username
                    : undefined,
                rules: [],
              })(<Input />)}
            </Form.Item>
            <Form.Item label={t('profile.currentPassword')} hasFeedback>
              {getFieldDecorator('currentPassword', {
                rules: [
                  {
                    required: true,
                    message: t('profile.pleaseInputCurrentPassword'),
                  },
                ],
              })(<Input.Password />)}
            </Form.Item>
            <Form.Item label={t('profile.newPassword')} hasFeedback>
              {getFieldDecorator('newPassword', {
                rules: [
                  {
                    required: true,
                    message: t('users.pleaseInputPassword'),
                  },
                  {
                    validator: validateToNextPassword,
                  },
                ],
              })(<Input.Password />)}
            </Form.Item>
            <Form.Item label={t('common.confirmPassword')} hasFeedback>
              {getFieldDecorator('confirm', {
                rules: [
                  {
                    required: true,
                    message: t('users.pleaseConfirmPassword'),
                  },
                  {
                    validator: compareToFirstPassword,
                  },
                ],
              })(<Input.Password onBlur={handleConfirmBlur} />)}
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Divider />
      <Row type="flex" justify="center">
        <Button type="primary" onClick={handleSubmit}>
          <CheckOutlined /> {t('common.save')}
        </Button>
      </Row>
    </Card>
  );
};
const WrappedSecurity = Form.create({ name: 'securityForm' })(Security);

Security.propTypes = {
  form: PropTypes.object,
  currentUser: PropTypes.object,
  saveSecurityDetailsAction: PropTypes.func,
};

function mapStateToProps() {
  return {};
}
export default connect(mapStateToProps, {
  saveSecurityDetailsAction,
})(WrappedSecurity);
